import { useEffect, useState } from "react";
import {
  IonToolbar, IonTitle, IonButtons, IonButton, IonList, IonSelect, IonSelectOption, IonInput,
} from "@ionic/react";
import FreshPopover from "./FreshPopover";

// The Tax Forms filter popover, the Purchases filter popover's twin: a
// toolbar (Filter, Clear, Apply) over stacked rows. Tax Year keeps the forms
// that can be made for that year (built-in years plus any the admin
// imported a template for); Min / Max narrow by the document's price; Free
// Document keeps what costs nothing (a free form for anyone, guests
// included, or one the signed-in person's plan or balance covers) or what
// is paid.
export const EMPTY_TAX_FILTERS = { taxYear: "", priceMin: "", priceMax: "", free: "" };

export const countActiveTaxFilters = (f) => Object.values(f || {}).filter((v) => v !== "" && v != null).length;

// forms: [{ key, ... }]; yearsByForm: { key: ["2025", ...] }; priceOf(form)
// -> number; isFree(form) -> boolean
export function applyTaxFormFilters(forms, f, { yearsByForm = {}, priceOf, isFree }) {
  if (!f || !countActiveTaxFilters(f)) return forms;
  return forms.filter((form) => {
    if (f.taxYear && !(yearsByForm[form.key] || []).includes(String(f.taxYear))) return false;
    const price = Number(priceOf ? priceOf(form) : 0) || 0;
    if (f.priceMin !== "" && price < Number(f.priceMin)) return false;
    if (f.priceMax !== "" && price > Number(f.priceMax)) return false;
    if (f.free) {
      const free = !!(isFree && isFree(form));
      if (f.free === "free" ? !free : free) return false;
    }
    return true;
  });
}

export default function TaxFormsFilterPopover({ open, event, onClose, filters, onApply, years = [] }) {
  const [draft, setDraft] = useState(filters || EMPTY_TAX_FILTERS);
  useEffect(() => { if (open) setDraft(filters || EMPTY_TAX_FILTERS); }, [open]); // eslint-disable-line
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v ?? "" }));

  const dropdownRow = (label, key, options, last) => (
    <div style={{ padding: last ? "12px 16px 16px" : "12px 16px 2px" }}>
      <IonSelect className="admin-field" mode="md" fill="outline" labelPlacement="floating" label={label}
        value={draft[key] || ""} onIonChange={(e) => set(key, e.detail.value)} interface="popover">
        {[{ value: "", label: "Any" }, ...options].map((o) => (
          <IonSelectOption key={o.value || "any"} value={o.value}>{o.label}</IonSelectOption>
        ))}
      </IonSelect>
    </div>
  );

  return (
    <FreshPopover open={open} event={event} onClose={onClose} className="purchases-filter-popover" style={{ "--width": "320px", "--max-width": "94vw", "--max-height": "calc(100vh - 140px)" }}>
      <div className="popover-viewport">
        <IonToolbar style={{ "--background": "var(--ion-card-background)", "--color": "var(--ion-text-color)" }}>
          <IonTitle style={{ fontWeight: 700 }}>Filter</IonTitle>
          <IonButtons slot="end">
            <IonButton color="danger" onClick={() => { setDraft(EMPTY_TAX_FILTERS); onApply?.(EMPTY_TAX_FILTERS); onClose?.(); }}>CLEAR</IonButton>
          </IonButtons>
          <IonButton slot="end" size="small" color="success" className="ion-margin-end" onClick={() => { onApply?.(draft); onClose?.(); }}>APPLY</IonButton>
        </IonToolbar>
        <IonList>
          {dropdownRow("Tax Year", "taxYear", years.map((y) => ({ value: String(y), label: String(y) })))}
          {/* Price range: the house inputs, paired */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, padding: "12px 16px 2px" }}>
            <IonInput className="admin-field" mode="md" fill="outline" labelPlacement="floating" label="Min $"
              type="number" inputmode="decimal" min="0" value={draft.priceMin}
              onIonInput={(e) => set("priceMin", e.detail.value)} placeholder="0" />
            <IonInput className="admin-field" mode="md" fill="outline" labelPlacement="floating" label="Max $"
              type="number" inputmode="decimal" min="0" value={draft.priceMax}
              onIonInput={(e) => set("priceMax", e.detail.value)} placeholder="20" />
          </div>
          {dropdownRow("Free Document", "free", [{ value: "free", label: "Free" }, { value: "paid", label: "Paid" }], true)}
        </IonList>
      </div>
    </FreshPopover>
  );
}
